import { ref, reactive, computed } from 'vue';
import { getTypesAll } from '../../../utils';

/**
 * Filtre durum verilerini oluşturur
 * @param {Object} documentState - Belge state verileri (bağımlılık)
 * @param {Object} categoryState - Kategori state verileri (bağımlılık)
 * @returns {Object} - Filtre state verileri
 */
export const createFilterState = (documentState, categoryState) => {
  // Filtre durumu
  const filters = reactive({
    fileType: null,
    categoryIds: [],
    dateFilter: null
  });
  
  const searchQuery = ref('');
  const showFilters = ref(false);
  const isFilterLoading = ref(false);
  
  // Tarih filtresi seçenekleri
  const dateFilterOptions = [
    { value: 'today', label: 'Bugün' },
    { value: 'yesterday', label: 'Dün' },
    { value: 'thisWeek', label: 'Bu Hafta' },
    { value: 'lastWeek', label: 'Geçen Hafta' },
    { value: 'thisMonth', label: 'Bu Ay' },
    { value: 'lastMonth', label: 'Geçen Ay' }
  ];
  
  // Dosya türü seçenekleri
  const fileTypeOptions = computed(() => {
    return getTypesAll().map(type => ({
      value: type.value,
      label: type.label
    }));
  });
  
  // Aktif filtreler
  const activeFilters = computed(() => {
    const result = {};

    if (filters.fileType) {
      const option = fileTypeOptions.value.find(opt => opt.value === filters.fileType);
      result.fileType = {
        label: 'Dosya Türü',
        value: option ? option.label : filters.fileType
      };
    }

    if (filters.categoryIds && filters.categoryIds.length > 0) {
      // Seçilen tüm kategorilerin adlarını bulup birleştir
      const selectedCategories = filters.categoryIds.map(catId => {
        const option = categoryState.categoryOptions.value.find(opt => 
          opt.value === catId || 
          opt.value === Number(catId) || 
          opt.value === String(catId)
        );
        return option ? option.label : `Kategori ${catId}`;
      });
      
      result.categoryIds = {
        label: 'Kategoriler',
        value: selectedCategories.join(', ')
      };
    }

    if (filters.dateFilter) {
      const option = dateFilterOptions.find(opt => opt.value === filters.dateFilter);
      result.dateFilter = {
        label: 'Tarih',
        value: option ? option.label : filters.dateFilter
      };
    }

    if (searchQuery.value) {
      result.search = {
        label: 'Arama',
        value: searchQuery.value
      };
    }

    return result;
  });
  
  const hasActiveFilters = computed(() => Object.keys(activeFilters.value).length > 0);
  const activeFilterCount = computed(() => Object.keys(activeFilters.value).length);

  return {
    filters,
    searchQuery,
    showFilters,
    isFilterLoading,
    dateFilterOptions,
    fileTypeOptions,
    activeFilters,
    hasActiveFilters,
    activeFilterCount
  };
};